import { profileAPI } from "../api";
import { ProfileUpdateRequest } from "../model";
import { formatUser } from "../../../entities/auth";
import { useMemberStore } from "../../auth/stores/member-store";

/**
 * 프로필 업데이트 Use Case
 * 검증 → API 호출 → 데이터 저장 → 포맷팅 전체 워크플로우
 */
export class UpdateProfileUseCase {
  async execute(userId: string, data: ProfileUpdateRequest) {
    // API 호출 (순수 HTTP)
    const response = await profileAPI.updateProfile(userId, data);

    // API 응답의 success 필드 확인
    if (!response.success) {
      throw new Error(response.message || "프로필 업데이트에 실패했습니다.");
    }

    // 사용자 정보 포맷팅
    let formattedUser = null;
    if (response.data?.user) {
      formattedUser = formatUser({
        id: response.data.user.id,
        user_id: response.data.user.user_id,
        email: response.data.user.email,
        name: response.data.user.name,
        phone_number: response.data.user.phone_number,
      });

      // Zustand store 업데이트
      const { setUser } = useMemberStore.getState();
      setUser(formattedUser);
    }

    return {
      user: formattedUser,
      message: response.message || "프로필이 성공적으로 업데이트되었습니다.",
    };
  }
}

export const updateProfileUseCase = new UpdateProfileUseCase();
